import {Button} from "../../../general/input/Button";
import React from "react";
import {format} from "date-fns";
import {useNavigate} from "react-router-dom";

const CompactOrder = ({order}) => {

    const navigate = useNavigate();
    const onSeeFullDetails = () => {
        navigate("/account/ordering/orders/" + order.id);
    }

    const orderedJSDate  = new Date(order.DateOrdered);
    const displayOrdered = format(orderedJSDate, "dd/MM/yy");

    return (
        <div className="account-compact-header">
            <div className="account-tile-header-detail">
                <p className="account-tile-h">Order</p>
                <p className="account-tile-h">Ordered</p>
                <p className="account-tile-h">Location</p>
                <p className="account-tile-b" style={{color: "var(--primary)"}}>{order.DocumentNo}</p>
                <p className="account-tile-b">{displayOrdered}</p>
                <p className="account-tile-b">{order.locationName}</p>
            </div>
            <Button className="button_clear" onClick={onSeeFullDetails}>Open</Button>
        </div>
    )

}

export default CompactOrder;
